import { Button } from '@heathmont/moon-core-tw';
import CopyToClipboard from 'react-copy-to-clipboard';
import Translate from '~/client/shared/i18n/Translate';

type Props = {
  walletAddress?: string;
  destinationTag?: string;
  currency: CashierCurrency;
  handleCopy: (currency?: CashierCurrency) => void;
};

const CopyButtons: FC<Props> = ({
  walletAddress = '',
  destinationTag,
  currency,
  handleCopy,
}) => (
  <div className=" grid grid-flow-col gap-4">
    <CopyToClipboard
      text={walletAddress.toString()}
      onCopy={() => handleCopy()}
    >
      <Button variant="secondary">
        <Translate id={`cashier.copy_${currency}_address`} />
      </Button>
    </CopyToClipboard>
    {destinationTag && (
      <CopyToClipboard
        text={destinationTag.toString()}
        onCopy={() => handleCopy(currency)}
      >
        <Button variant="secondary">
          <Translate id="cashier.deposit_destination_tag" />
        </Button>
      </CopyToClipboard>
    )}
  </div>
);

export default CopyButtons;
